<span class="uni-table-action__text" *ngIf="text">
  {{ text }}
</span>
<uni-icon [name]="name" [style]="style" class="uni-table-action__icon"></uni-icon>
